import { Heading, Skeleton } from '@digdir/designsystemet-react';
import React from 'react';

import { PageWrapper } from './styledComponents';

export const EnergiattestLoader = () => {
  return (
    <PageWrapper>
      <Heading level={1} data-size="xl">
        <Skeleton variant="text" width={15} />
      </Heading>
      <Skeleton variant="rectangle" width="100%" height="170px" />
      <Skeleton variant="rectangle" width="100%" height="300px" />
    </PageWrapper>
  );
};
